module.exports = __webpack_public_path__ + "static/media/unilabs.5e547d92.png";